export default __webpack_public_path__ + "static/media/decor4.63589e1c.webp";